import React, { FC, ReactElement } from 'react';
import type { Route } from 'next';
import classNames from 'classnames/bind';
import Link from 'next/link';
import styles from 'sections/Resources/FreightForwarder/components/Countries/components/ListItem/ListItem.module.scss';

const cn = classNames.bind(styles);

type ListItemProps = {
  name: string;
  url: string;
}

const ListItem: FC<ListItemProps> = ({ name, url }: ListItemProps): ReactElement => {
  return (
    <Link className={cn('list-item')} href={`freight-forwarder/${url}` as Route}>{name}</Link>
  );
};

export { ListItem };